import { faPlusLarge } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@progress/kendo-react-buttons";
import { userData } from "../Common/Store/CommonSignals";

function CreateButton({ component, onClick }) {
  const userRolePerms = userData.value?.permissions;

  return (
    <Button
      className="btn-square"
      themeColor={"primary"}
      hidden={!userRolePerms.Modify.includes(component)}
      onClick={onClick}
    >
      <FontAwesomeIcon
        icon={faPlusLarge}
        style={{ marginRight: "5px" }}
      />
      {component}
    </Button>
  );
}

export default CreateButton;
